var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-overlay',{model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"128"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }